import React from "react";
import { FormContext } from "./FormContext";

export function useFormContext() {
    return React.useContext(FormContext);
}
